import Extend from 'flarum/common/extenders';
import Discussion from 'flarum/common/models/Discussion';
import Forum from 'flarum/common/models/Forum';
import Tag from 'ext:flarum/tags/common/models/Tag';
import Language from './models/Language';
import LanguageGambit from './gambits/LanguageGambit';
export default [new Extend.Store() //
.add('discussion-languages', Language), new Extend.Model(Discussion) //
.hasOne('language').attribute('canChangeLanguage'), new Extend.Model(Forum) //
.hasMany('discussionLanguages'), new Extend.Model(Tag) //
.attribute('subscriptionLanguage').attribute('localisedLastDiscussion'), new Extend.Search() //
.gambit('discussions', LanguageGambit)];